import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { PureComponent, Children } from 'react';
import { DecisionList as AkDecisionList } from '@atlaskit/task-decision';
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
var DecisionList = /*#__PURE__*/function (_PureComponent) {
  function DecisionList() {
    _classCallCheck(this, DecisionList);
    return _callSuper(this, DecisionList, arguments);
  }
  _inherits(DecisionList, _PureComponent);
  return _createClass(DecisionList, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      if (Children.count(children) === 0) {
        return null;
      }
      return /*#__PURE__*/React.createElement(AkDecisionList, null, children);
    }
  }]);
}(PureComponent);
export { DecisionList as default };